<template>
  <li class="App-list__item">
    <span class="App-list__item-content flex flex--row">
      <span class="App-list__item-avatar">
        <i class="material-icons App-list__item-icon">{{icon}}</i>
      </span>
      <span class="App-list__item-body flex flex--column">
        <span class="App-list__item-body--label">
          <slot name="label"></slot>
        </span>
        <span class="App-list__item-body--text">
          <slot name="content"></slot>

          <span v-if="!hideChangeLinks">(<a class="App-list__item-body--link-text" @click="doAction()">Change</a>)
          </span>
        </span>
      </span>
    </span>
  </li>
</template>

<script>
// import api from '@/api';
import {mapGetters, mapActions} from 'vuex';

export default {
  props: {
    icon: {
      type: String,
      required: true
    },
    route: {
      type: String,
      required: true
    },
    hideChangeLinks: {
      type: Boolean,
      default: false
    }
  },
  computed: {
    ...mapGetters({steps: 'steps'})
  },
  methods: {
    ...mapActions(['setNextToReview']),
    doAction() {
      // Track review change
      this.setNextToReview(true);
      this.$router.push({path: this.route});
    }
  },
  mounted() {
    componentHandler.upgradeElement(this.$el);
  }
};
</script>

<style scoped>
.App-list__item {
  padding: 5px;
  margin-bottom: 10px;
  border-radius: 4px;
  border-bottom: 1px solid #dedede;
}
.App-list__item-avatar {
  padding: 5px 10px 5px 10px;
}
.App-list__item-icon {
  font-size: 2.5rem;
  opacity: 0.87;
}
.App-list__item-body {
  padding: 5px;
}
.App-list__item-body--label {
  font-size: 0.95rem;
  color: rgb(63, 81, 181);
  line-height: 1.35;
  padding-bottom: 0.2rem;
}
.App-list__item-body--text {
  font-size: 0.95rem;
  font-weight: bold;
  color: #212121;
  opacity: 0.87;
  line-height: 1.45;
}
.App-list__item-body--text:first-letter {
  text-transform: capitalize;
}
.App-list__item-body--link-text {
  font-size: 0.9rem;
  cursor: pointer;
  cursor: hand;
}
</style>



// WEBPACK FOOTER //
// src/components/Review/ReviewListItem.vue